import * as cookies from 'Jsx/Utils/cookies';
import { CountryPrefix } from 'Jsx/global.d';

export const COOKIES_CONSENT_KEY = 'SHOW_COOKIES_NOTIFICATION';

export const shouldShowCookiesMessage = () => {
  const showCookiesNotification = cookies.getAll()[COOKIES_CONSENT_KEY];

  return !showCookiesNotification;
};

export const updateExpressFacebookLoginPosition = () => {
  const mainMenu = document.getElementById('MainMenuComponent');

  const facebookRecurrentLoginDialog = document.getElementById(
    'facebookExpressLoginRoot',
  );

  if (mainMenu && facebookRecurrentLoginDialog) {
    const mainMenuHeight = mainMenu.clientHeight;

    facebookRecurrentLoginDialog.style.top = `${mainMenuHeight + 10}px`;
    facebookRecurrentLoginDialog.style.display = 'block';
  }
};

export const defaultProps = {
  mode: undefined,
  position: 'absolute',
  hideLeftLinks: false,
  hideShoppingCart: false,
  hideSearchBar: false,
  hideMembershipButton: false,
  hideWishList: false,
  hideMembershipLink: false,
  hideComunityLink: false,
  hideAffiliate: false,
  hideAllRightLinks: false,
  hideNotifications: false,
  hideBlogLink: false,
  hideLivesLink: false,
  hideMyCoursesLink: false,
  hideAll: false,
  hideTopBanner: false,
  CDU: false,
  organization: undefined,
  crehanaBaseUrl: '',
  loginRegisterSwitcherProps: {},
  countryPrefix: '' as CountryPrefix,
  hideModalLeave: false,
  showHubLinks: false,
  customLogoColor: undefined,
  withoutTopBannerComponent: false,
  showMembershipPromo: false,
  blogCategories: [],
};
